import { Button } from "@design-system/shadcn";
import { X } from "lucide-react";
import React, { type ComponentProps } from "react";

import { useFilters } from "../filters-provider";

interface FilterBarClearProps extends Omit<
  ComponentProps<typeof Button>,
  "children" | "onClick" | "variant"
> {
  label: string;
  onClear?: () => void;
}

function FilterBarClear({
  label,
  className,
  onClear,
  ...props
}: FilterBarClearProps) {
  const { hasActiveFilters, clearAll } = useFilters();

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <Button
      {...props}
      type="button"
      variant="ghost"
      onClick={() => {
        clearAll();
        onClear?.();
      }}
      className={className}
    >
      <X aria-hidden />
      {label}
    </Button>
  );
}

export { FilterBarClear };
export type { FilterBarClearProps };
